import Email from "components/icons/Email";
import Eye from "components/icons/Eye";
import Password from "components/icons/Password";
import React, { InputHTMLAttributes, useState } from "react";
import { useTranslation } from "react-i18next";

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  icon?: "email" | "password";
  showPassword?: boolean;
  ref?: React.Ref<HTMLInputElement>;
}

export function Input({ icon, showPassword, ref, ...props }: InputProps) {
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const { t } = useTranslation();
  const accessibleLabel =
    props["aria-label"] ?? props.name ?? props.placeholder ?? undefined;
  const passwordToggleLabel = isPasswordVisible
    ? t("hide_password")
    : t("show_password");

  return (
    <div
      className={`flex items-center ${
        icon ? "px-3" : "px-4"
      } py-3 max-md:py-[14px] gap-[10px] bg-grey-600 border border-grey-400 rounded-lg min-w-[300px] focus-within:border-azulfy-blue focus-within:ring-2 focus-within:ring-azulfy-blue/20`}
    >
      {icon === "email" && <Email aria-hidden="true" role="presentation" />}
      {icon === "password" && (
        <Password aria-hidden="true" role="presentation" />
      )}
      <input
        {...props}
        ref={ref}
        type={isPasswordVisible ? "text" : props.type}
        aria-label={accessibleLabel}
        spellCheck={
          props.spellCheck ?? (props.type === "email" ? false : undefined)
        }
        className="w-full bg-transparent border-none outline-none text-azulfy-rich-black max-md:text-sm font-bold font-comfortaa opacity-70"
      />
      {showPassword && (
        <button
          type="button"
          onClick={() => setIsPasswordVisible(!isPasswordVisible)}
          aria-label={passwordToggleLabel}
          title={passwordToggleLabel}
          className="rounded-full focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-azulfy-blue/30"
        >
          <Eye
            isPasswordVisible={isPasswordVisible}
            aria-hidden="true"
            role="presentation"
          />
        </button>
      )}
    </div>
  );
}
